import React from "react";
import styled from "styled-components";

import { Button } from "src/library/components/Button";
import {
  BasicModal,
  BasicModalProps
} from "src/library/components/Modal/BasicModal";

import { UserMultiSelect } from "./UserMultiSelect";

export interface SelectUsersModelProps extends Pick<BasicModalProps, "onDismiss" | "open"> {
  onSave: (userIds: number[]) => void;
  alreadySelectedUserIds: string[];
}

export const SelectUsersModel: React.ReactFCWithChildren<SelectUsersModelProps> = ({
  onDismiss, open, onSave, alreadySelectedUserIds
}) => {
  const [ selectedUsers, setSelectedUsers ] = React.useState<string[]>([]);

  return (
    <StyledBasicModal
      title="select users"
      open={open}
      onDismiss={() => onDismiss()}
    >
      <UserMultiSelect
        key="search"
        onUsersChange={change => setSelectedUsers(change.usersSelected)}
        userFilters={{ defaultCustomerId: null }}
        disabledOptions={alreadySelectedUserIds}
      />

      <Button
        className="action-save-button"
        disabled={!selectedUsers.length}
        onClick={() => onSave(selectedUsers.map(userId => parseInt(userId)))}
      >
        Save
      </Button>
    </StyledBasicModal>
  );
};

const StyledBasicModal = styled(BasicModal)`
  max-height: calc(100vh - 40px);
  overflow-y: scroll;
  min-height: 400px;

  .action-save-button {
    margin-top: ${({ theme }) => theme.spacing.margins.md};
  }
`;
